import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Calculator from "./components/Calculator"; 
import About from "./pages/About";
import WhoWeServe from "./pages/WhoWeServe";
import MutualFunds from "./pages/MutualFunds"
import PMSAIF from "./pages/Pms"
import Bonds from "./pages/Bonds"
import SP from "./pages/SP";
import Legacy from "./pages/Legacy";
import Insurance from "./pages/Insurance";
import BespokePortfolios from "./pages/Bespoke"
import FAQs from './pages/FAQs';
import Connect from './pages/Connect';
import PrivacyPolicy from "./pages/privacypolicy";
import Disclaimer from "./pages/disclaimer";
import Disclosure from "./pages/disclosure";
import Blogs from "./pages/blogs";
import Media from "./pages/Media";
// import About from "./pages/About"; // Make sure to move About.tsx to the pages or components folder

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white">
       
        <Header />

        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
          {/*  <Route path="/about" element={<About />} />  */}
            <Route path="/calculator" element={<Calculator />} />
        {  /*  <Route path="/faqs" element={<FAQs />} /> */}
        <Route path="/about" element={<About />} />
        {/* ✅ ADD THIS */}
  <Route path="/who-we-serve" element={<WhoWeServe />} />
   <Route path="/mutual-funds" element={<MutualFunds />} />
    <Route path="/pms--aif" element={<PMSAIF />} />
     <Route path="/bonds" element={<Bonds />} />
       <Route path="/structured-products" element={<SP />} />
        <Route path="/legacy--estate-planning" element={<Legacy />} />
         <Route path="/insurance" element={<Insurance />} />
         {/* <Route path="/equity" element={<Equity />} /> */}
          <Route path="/bespoke-portfolios" element={<BespokePortfolios />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/connect" element={<Connect />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
             <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/disclosure" element={<Disclosure />} />
               <Route path="/blogs" element={<Blogs />} />
              <Route path="/media" element={<Media/>} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}